<template>
  <div class="mb-24 flex items-center">
    <IconInfo />
    <p class="body-1 ml-12">
      {{ i18n(translations.info) }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconInfo } from '@ds/icons/IconInfo'

import translations from './ShippingInfo.translations'

const i18n = useI18n()
</script>
